export default "__VITE_ASSET__65464c18__"